import { msgTypes } from 'constants/msgTypes';
import { useEffect, useRef, useState } from 'react';
import ApiUrl from 'services/shared/ApiUrl';
import { UtilService } from 'services/shared/UtilService';
import './PreviousEvents.scss';

const UpcomingEvents = () => {
  const [upcomingEventList, setUpcomingEventList] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
          videoRef.current.playbackRate = 1; // 0.5x speed (half speed)
        }
      }, []);
  useEffect(() => {
    loadUpcomingEventList()
  }, [])

  const loadUpcomingEventList = async () => {
    const res = await UtilService.getUpcomingEventList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setUpcomingEventList(res.data)
        //setUpcomingEventList([])
      } else {
        setUpcomingEventList([])
      }
    }
  }

  const UpcomingEvents = () => {
    return (
      <>
       {upcomingEventList.map((event, index) => {
  return (
    <div key={index} className='row p-5 events-up'>
      <div className='col-lg-6 d-flex justify-content-center'>
        <div className='event-img'>
          <img 
            src={event.image ? ApiUrl.fileBaseUrl + event.image : "/images/events/no_images.png"} 
            alt={event.eventName} 
            style={{
              width: "100%",   // Fixed width
              height: "200px",  // Fixed height
              objectFit: "cover",  // Ensures proper image fit
              borderRadius: "10px" // Optional: Rounded corners
            }}
          />
        </div>
      </div>
      <div className='col-lg-6'>
        <div className="events-3-holder h-100">
          <div className="events-3-description-holder">
            <h3>{event.eventName}</h3>
            <h6 className='p-0 m-0' style={{ fontFamily: 'Arial', fontWeight: 400 }}>
              <span style={{ color: '#030935', fontWeight: '700' }}>Date</span>  : &nbsp;&nbsp;
              <span style={{ fontWeight: 500 }}>
                {UtilService.displayEventDate(event.eventStartDate, event.eventEndDate)}
              </span>
            </h6>
            <h6 className='p-0 m-0' style={{ fontFamily: 'Arial', fontWeight: 400 }}>
              <span style={{ color: '#030935', fontWeight: '700' }}>Venue</span> : &nbsp;&nbsp;
              <span style={{ fontWeight: 500 }}>
                {event.eventVenue}
              </span>
            </h6>
            <div className="faq-one__btn-box contact-btn d-flex">
              <button className="register-btn" onClick={() => window.open(event.createConference, "_blank")}>
                Know More
                <span className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M13.293 12l-4.147-4.146a1 1 0 011.415-1.415l5 5a1 1 0 010 1.415l-5 5a1 1 0 01-1.415-1.415L13.293 12z"></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
})}

      </>
    )
  }

  return (
    <>

      {/* <!--Page Header Start--> */}
      <section className="page-header event-banner member-section">
      <section className="page-header advisor-banner member-section">
                <video ref={videoRef} autoPlay muted loop playsInline>
                    {/* <source src="/images/video/ConferenceVideo.mp4" type="video/mp4" /> */}
                    <source src="https://www.oneworldnetwork.co/video/1wn-conference-video.mp4" type="video/mp4" />

                </video>
           
                <div className="page-header__bg post-event-gallery-banner">
                </div>
           
            </section>
        <div className="page-header__bg ">

        </div>
        <div className="container membership-container">
          <div className="page-header__inner membership-head">
    
          </div>

        </div>
      </section>
      {/* //   <!--Page Header End--> */}



      <div className='container heading-previous-event'>
        <div className='row'>
          <div className='col-lg-12'>
            <h1 className='upcoming--'>Upcoming Events</h1>
          </div>
        </div>
      </div>

      <div className='container upcoming-work'>
        {upcomingEventList.length > 0 ? (
          <UpcomingEvents />
        ) : (
          <div className='event-imp d-flex justify-content-center'>
            <img src='/images/events/no-schedule-events.jpg' width={300} height={300}></img>
          </div>
        )}

      </div >
    </>
  )
}

export default UpcomingEvents